
import { useState, useRef, useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from 'react-redux';

//Components
import { Grid } from "@mui/material";
import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
    Input,
    Form,
    Select,
} from "@gpstrackit/react-controls";
import CustomCard from 'Components/Card';
import CustomSelect from 'Components/Select';

//Notification
import { NotificationManager } from "Components/Notifications";

//Styles
import './unassignDrivers.scss';

//Actions
import {
    unassignDriversGetKeyFobRequest,
    unassignDriversSetDevice,
    unassignDriversRequest,
    clearRedux,
} from 'Redux/actions';

import { getAccounts } from './redux/saga'

const unassignDrivers = (props) => {
    const formRef = useRef(null);
    const formTwoRef = useRef(null);
    const { messages } = useIntl();
    const { tableRef, single, getDevice, account } = props;
    const dispatch = useDispatch();

    //Redux States
    const { keyFob, loading, openModal, result, selectedKeyFobs } = useSelector(state => state.unassignDriversRedux)

    //Local States
    const [keyfobs, setKeyFobs] = useState([]);
    const [serial, setSerial] = useState("");


    const searchKeyFob = () => {
        let keyFobSearchCriteriaArr = serial.split(/[\s,;\t\n]+/);
        if (keyFobSearchCriteriaArr.length > 1) {
            let criterias = [];

            keyFobSearchCriteriaArr.forEach(criteria => {
                let escCriteria = criteria.trim();

                let regx = /[^a-zA-Z0-9]/g;
                escCriteria = escCriteria.replace(regx, '');

                if (keyfobs && keyfobs.length) {
                    for (let index in keyfobs) {
                        let keyfob = keyfobs[index];

                        if (keyfob.hex != escCriteria) {
                            criterias.push(escCriteria?.trim());
                        }
                    }
                } else {
                    criterias.push(escCriteria?.trim());
                }
            });

            if (criterias.length) {
                dispatch(unassignDriversGetKeyFobRequest(criterias));
            }

        } else {

            let isValid = true;
            for (let index in keyfobs) {
                let keyfob = keyfobs[index];
                if (keyfob.hex.toString() === serial?.trim()) {
                    isValid = false;
                    break;
                }
            }

            if (isValid) {
                dispatch(unassignDriversGetKeyFobRequest(serial?.trim()));
            } else {
                NotificationManager.warning(
                    messages['unassign_drivers_device_is_already_added'],
                    messages['unassign_drivers_title'],
                    3000
                );
            }
        }
    }

    const closeModal = () => {
        setSerial("");
        setKeyFobs([]);
        dispatch(clearRedux("UNASSIGN_DRIVERS"));
    }

    const applyChanges = () => {
        let deviceValidation = keyfobs.some((item) => item.status === 1)

        let keyFobIds = keyfobs.map((item) => (item?.hex))
        let payload = {
            keyFobIds
        }
        dispatch(unassignDriversRequest(payload))
    }

    const getAccountsForSelect = (input, callback) => {
        if (!input) {
            callback([])
            return
        }
        getAccounts(input).then((response) => {
            if (response.result) {
                const { items } = response?.result
                callback(items)
            }
        })
    }


    useEffect(() => {

        if (keyFob) {
            dispatch(clearRedux("UNASSIGN_DRIVERS", { keyFob: null }));
            if (!keyFob?.total) {
                NotificationManager.warning(
                    messages['unassign_drivers_device_has_not_been_found'],
                    messages['unassign_drivers_title'],
                    3000
                );
            } else {
                let items = keyFob.items;
                if (items?.length > 0) {
                    setSerial("");
                    let newItems = [...keyfobs, ...items]
                    dispatch(unassignDriversSetDevice(newItems))
                    setKeyFobs([...newItems]);
                }
            }

        }
        if (result?.updateMoveAccount) {
            NotificationManager.success(
                single ? messages['unassign_drivers_single_success_message'] : messages['unassign_drivers_multiple_success_message'],
                messages['unassign_drivers_title'],
                3000
            );
            closeModal();
            getDevice && getDevice();
            tableRef && tableRef?.current?.getData();
        } else if (result && !result?.updateMoveAccount) {
            NotificationManager.error(
                messages['unassign_drivers_error_message'],
                messages['unassign_drivers_title'],
                3000
            );
            dispatch(clearRedux("UNASSIGN_DRIVERS", { result: null }))
        }
        if (selectedKeyFobs && selectedKeyFobs.length > 0) {
            setKeyFobs([...selectedKeyFobs]);
            dispatch(clearRedux("UNASSIGN_DRIVERS", { selectedKeyFobs: [] }))
        }
    }, [keyFob, result, selectedKeyFobs])

    return (
        <Modal
            open={openModal}
            title={messages['unassign_drivers_title']}
            position="right"
            size="small"
            handleClose={closeModal}
            loading={loading}
        >
            <ModalBody>
                {
                    <div style={{ padding: '0 10px' }}>
                        <Grid
                            container
                            spacing={1}
                        >
                            <Grid item xs={10}>
                                <Form
                                    ref={formRef}
                                    onValidSubmit={() => searchKeyFob()}
                                >
                                    <Input
                                        label={messages['unassign_drivers_input']}
                                        placeholder={messages['unassign_drivers_input']}
                                        value={serial}
                                        required
                                        requiredMessage={messages['required_field']}
                                        onChange={(value) => setSerial(value)}
                                    />
                                </Form>
                            </Grid>
                            <Grid item xs={2}>
                                <div style={{ marginTop: 26 }}>
                                    <Button
                                        className="btn-dark-blue"
                                        onClick={() => formRef?.current?.submit()}
                                    >
                                        {messages['common_add']}
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: 26 }}>
                                <label style={{ fontWeight: 600 }}>{messages['unassign_drivers_confirm']}</label>
                            </Grid>
                        {
                            keyfobs?.length > 0 &&
                            <Grid item xs={12} style={{ marginTop: 26 }}>
                                <label style={{ fontWeight: 700 }}>{messages['unassign_drivers_keyfobs']}</label>
                            </Grid>
                        }
                        {keyfobs.length > 0 ? keyfobs.map((item, index) => {
                            return (
                                <CustomCard
                                    key={index}
                                    onClick={() => {
                                        let currentDevices = keyfobs;
                                        let selected = currentDevices.findIndex((keyfob) => keyfob.id === item.id);
                                        if (selected > -1) currentDevices.splice(selected, 1);
                                        dispatch(unassignDriversSetDevice(currentDevices));
                                    }}
                                >
                                    <div style={{ display: 'grid' }}>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['unassign_drivers_identifier']}</label><span>{item.hex}</span>
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['unassign_drivers_driver']}</label><span>{item?.driver?.name}</span>
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['unassign_drivers_account']}</label><span>{item?.company?.name}</span>
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['unassign_drivers_model']}</label><span>{item?.keyFobModel?.name}</span>
                                        </div>
                                    </div>
                                </CustomCard>
                            )
                        }) : <div style={{ display: 'flex', justifyContent: 'center', marginTop: 25 }} ><span style={{ opacity: 0.6 }} >{messages['common_no_keyfobs_added']}</span></div>}
                    </div>
                }

            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => {
                        if (keyfobs.length === 0) {
                            NotificationManager.warning(
                                messages['unassign_drivers_no_devices_added'],
                                messages['unassign_drivers_title'],
                                3000
                            );
                        } else {
                            //account from selected and keyfobs added 
                            applyChanges();
                        }
                    }}
                >
                    {messages['unassign_drivers_change']}
                </Button>
            </ModalFooter>
        </Modal >
    )
}

export default unassignDrivers;